import { render } from "./SticksModal.vue?vue&type=template&id=99c05cf8&scoped=true&ts=true"
import script from "./SticksModal.vue?vue&type=script&lang=ts"
export * from "./SticksModal.vue?vue&type=script&lang=ts"

import "./SticksModal.vue?vue&type=style&index=0&id=99c05cf8&lang=scss&scoped=true"

import exportComponent from "/opt/booza-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99c05cf8"]])

export default __exports__